// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentInsVerRequestModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentInsVerRequestModel.attributeTypeMap;
    }
}
ExtEnrollmentInsVerRequestModel.discriminator = undefined;
ExtEnrollmentInsVerRequestModel.additionalProperties = false;
ExtEnrollmentInsVerRequestModel.attributeTypeMap = [
    {
        "name": "insuranceVerification",
        "baseName": "insuranceVerification",
        "type": "ExtEnrollmentInsuranceVerificationModel"
    },
    {
        "name": "survey",
        "baseName": "survey",
        "type": ""
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "ExtEnrollmentDemographicsModel"
    },
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "ExtEnrollmentClientIdentifiersModel"
    },
];
//# sourceMappingURL=extEnrollmentInsVerRequestModel.js.map